import { TriggerSpine } from 'core/display/spines/TriggerSpine'
export  class ReplaceTriggerSpine extends TriggerSpine {
  constructor(data) {
    super(data)
  }
}
